import { apiJson } from "../../../shared/lib/api-client.ts";
import type { ApiResponse } from "../../leaderboard/types/index.ts";
import type { TrendsDashboard, TrendsSummary } from "../types/index.ts";

export async function getTrendsSummary(): Promise<TrendsSummary | null> {
  const payload = await apiJson<ApiResponse<TrendsSummary>>("/v1/trends/summary");
  return payload.data ?? null;
}

export async function getTrendsDashboard(period: 7 | 30 | 90): Promise<TrendsDashboard | null> {
  const payload = await apiJson<ApiResponse<TrendsDashboard>>(
    `/v1/trends/dashboard?period=${period}`
  );
  return payload.data ?? null;
}
